import React from 'react';
import PDFRenderUtils from "utils/PDFRenderUtils";
import { View, StyleSheet } from '@react-pdf/renderer';
import PDFTableCell from './PDFTableCell';

const PDFTableRow = (props) => {
    const { width, height, disableMargin, border } = props;
    const styles = StyleSheet.create({
        tableRow: {
            display: 'flex',
            flexDirection: 'row',
            borderWidth: border,
            borderLeftWidth: border,
            borderTopWidth: border,
            // borderRadius: 5,
            borderStyle: "solid",
            borderColor: '#000000',
            marginLeft: 0,
            marginRight: 0,
            marginTop: -1
        }
    });

    let style = {
        width: width + "%",
        flexDirection: "row",
        //flexWrap: "wrap"
    };

    if (width) {
        style.width = width + "%";
    } else {
        style.width = "auto";
    }
    if (height) {
        style.height = height + "px";
    } else {
        style.height = "auto";
    }

    if (disableMargin) {
        style.margin = 0;
    }

    const validChildren = React.Children.toArray(props.children).filter(Boolean);
    let totalWidth = validChildren.map(child => child?.props?.width || 0);

    const renderChildren = validChildren.map((child) => {
        if (child.type === PDFTableCell) {
            return React.cloneElement(child, { __totalElements: validChildren.length, __elementsWidthArray: totalWidth, });
        }
        if (child.type === PDFTableRow) {
            return React.cloneElement(child);
        }
        return null;
    })
    return (
        <>
            <View wrap={false} style={PDFRenderUtils.combineStyles(styles.tableRow, style)}>
                {renderChildren}
            </View>
        </>
    )
}

PDFTableRow.defaultProps = {
    width: 0,
    height: 0,
    disableMargin: false,
    border: 1
}


export default PDFTableRow;
